// firebaseConfig.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { store } from "@/store/store";

// --- Default Firebase App ---
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIRE_API_KEY,
  authDomain: process.env.VUE_APP_FIRE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIRE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIRE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIRE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIRE_APP_ID,
  measurementId: process.env.VUE_APP_FIRE_MEASUREMENT_ID,
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);
const analytics = getAnalytics(app);
const defaultDB = getFirestore(app);

// --- FCM Messaging Initialization ---
async function initFirebaseMessaging() {
  try {
    if (await isSupported()) {
      const messaging = getMessaging(app); // use default app
      const token = await getToken(messaging, { vapidKey: process.env.VUE_APP_FIRE_VAPID_KEY });

      if (token) {
        localStorage.setItem("fcmToken", token);
        console.log("FCM Token:", token);

        // Subscribe to topics
        store.dispatch("fcmMessagingSubscribeToTopic", "BROADCAST")
          .then(() => console.log("Subscribed to topic: BROADCAST"))
          .catch(() => console.log("Not subscribed to topic: BROADCAST"));

        store.dispatch("fcmMessagingSubscribeToTopic", "PC")
          .then(() => console.log("Subscribed to topic: PC"))
          .catch(() => console.log("Not subscribed to topic: PC"));
      } else {
        console.log("No FCM token available. Request permission to generate one.");
      }
    } else {
      console.log("Firebase messaging is not supported in this browser.");
    }
  } catch (error) {
    console.error("Error initializing FCM:", error);
  }
}

export { app, auth, analytics, defaultDB, initFirebaseMessaging };
